// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `angular.json`.

// `.env.ts` is generated by the `npm run env` command
import env from "./.env";

// The `window.env` object is loaded in the `index.html` file
const loadedEnv = window.env || {};
const asBoolean = (value: unknown): boolean =>
  value === true || value === "true";

export const environment = {
  production: false,
  version: env.LOS_x.version,
  hash: env.LOS_x.hash,
  // For connecting to server running elsewhere update the tenant identifier
  fineractPlatformTenantId: loadedEnv.fineractPlatformTenantId || "default",
  fineractPlatformTenantIds: loadedEnv.fineractPlatformTenantIds || "default",
  // For connecting to others servers running elsewhere update the base API URL
  baseApiUrls:
    loadedEnv.fineractApiUrls ||
    "https://cbs.firstfintech.com/be," + window.location.origin,
  // For connecting to server running elsewhere set the base API URL
  baseApiUrl:
    loadedEnv.fineractApiUrl ||
    (loadedEnv.fineractApiUrls?.length > 0
      ? loadedEnv.fineractApiUrls.split(",")[0]
      : "https://cbs.firstfintech.com/be"),
  allowServerSwitch: loadedEnv.allowServerSwitch || "true",
  apiProvider: loadedEnv.apiProvider || "/fineract-provider/api",
  apiVersion: loadedEnv.apiVersion || "/v1",
  apiActuator: loadedEnv.apiActuator || "/fineract-provider",
  serverUrl: "",
  /** Feature flag for Remember Me functionality */
  enableRememberMe: false,
  oauth: {
    enabled: asBoolean(loadedEnv.oauthServerEnabled), // For connecting to LOS X using OAuth2 Authentication change the value to true
    serverUrl: loadedEnv.oauthServerUrl || "",
    appId: loadedEnv.oauthAppId || "",
  },
  warningDialog: {
    title: "Warning",
    content:
      "This system is for authorized use only. Unauthorized access will result in possible legal action. By accessing this system, you acknowledge that you are authorized to do so and that all data stored and processed here is confidential.",
    buttonText: "Close",
  },
  defaultLanguage: loadedEnv.defaultLanguage || "ar-AR",
  supportedLanguages: loadedEnv.supportedLanguages || "en-US,ar-AR",
  preloadClients: loadedEnv["preloadClients"] || true,

  defaultCharDelimiter: loadedEnv.defaultCharDelimiter || ",",

  displayBackEndInfo: loadedEnv.displayBackEndInfo || "true",
  displayTenantSelector: loadedEnv.displayTenantSelector || "true",
  // Time in seconds, default 60 seconds
  waitTimeForNotifications: loadedEnv.waitTimeForNotifications || 60,
  // Time in seconds, default 30 seconds
  waitTimeForCOBCatchUp: loadedEnv.waitTimeForCOBCatchUp || 30,
  session: {
    timeout: {
      idleTimeout: loadedEnv.sessionIdleTimeout || 300000, // 5 minutes
    },
  },
  httpCacheEnabled: loadedEnv.httpCacheEnabled || false,

  vNextApiUrl: window.env?.vNextApiUrl || "https://apis.flexcore.mx",
  vNextApiProvider: window.env?.vNextApiProvider || "/vnext1",
  vNextApiVersion: window.env?.vNextApiVersion || "/v1.0",
  interbankTransfers: window.env?.interbankTransfers || false,

  minPasswordLength: loadedEnv.minPasswordLength || 12,

  OIDC: {
    oidcServerEnabled: asBoolean(window["env"]["oidcServerEnabled"]),
    oidcBaseUrl: window["env"]["oidcBaseUrl"] || "",
    oidcClientId: window["env"]["oidcClientId"] || "",
    oidcApiUrl: window["env"]["oidcApiUrl"] || "",
    oidcFrontUrl: window["env"]["oidcFrontUrl"] || "",
  },
};

// Server URL
environment.serverUrl = `${environment.baseApiUrl}${environment.apiProvider}${environment.apiVersion}`;
